import { attendreLesEcritures } from './api/client';

/**
 * Ce que la fenêtre de bureau demande à la page avant de fermer (desktop/src/main.ts, ticket 23).
 *
 * Les champs s'enregistrent quand on les quitte (Saisies, ChampsNotes) : un texte en cours de
 * frappe n'est encore parti nulle part au moment de la croix. On quitte donc le champ actif,
 * on laisse à React le temps de lancer l'envoi, puis on attend que le serveur ait répondu.
 * La fenêtre ne patiente que trois secondes au plus.
 *
 * Dans un navigateur, personne n'appelle cette fonction : elle ne change rien.
 */
declare global {
  interface Window {
    nextilt?: { envoyerCeQuiAttend: () => Promise<void> };
  }
}

const LAISSER_PARTIR_MS = 150;

export function brancherLaFermeture(): void {
  window.nextilt = {
    envoyerCeQuiAttend: async () => {
      const actif = document.activeElement;
      if (actif instanceof HTMLElement) actif.blur();
      await new Promise((resoudre) => setTimeout(resoudre, LAISSER_PARTIR_MS));
      await attendreLesEcritures();
    },
  };
}
